import { ASSET_TYPES } from '../components/LandingPageSidePanel/constants';

import {
  INVALID_REQUEST_ACCESS_STATUS,
  INVALID_SESSION_STATUS,
  LISTROW_TYPES,
} from './constants';

export const isSession = (item) => item.type === LISTROW_TYPES.SESSION;

export const isInvalidSessionStatus = (status) =>
  INVALID_SESSION_STATUS.includes(status);

export const isInvalidRequestAccessStatus = (status) =>
  INVALID_REQUEST_ACCESS_STATUS.includes(status);

export const isAccount = (item) => item.type === LISTROW_TYPES.ACCOUNT;

export const isEndpoint = (item) => item.type === LISTROW_TYPES.ENDPOINT;
export const isRole = (item) =>
  item.type === LISTROW_TYPES.ROLE || Boolean(item.roleKey);
export const isApp = (item) => item.assetType === ASSET_TYPES.APPLICATION;

export const hasSelectedRoles = (selectedRoles) =>
  Boolean(selectedRoles && selectedRoles?.length > 0);

export const formatDate = (date) => date.toISOString().split('T')[0];
